import React from 'react';

const DiamondIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.5003 3L8.00033 9L12.0003 22M12.0003 22L16.0003 9L13.5003 3M12.0003 22C12.3175 22 12.6297 21.9245 12.912 21.7799C13.1943 21.6352 13.4381 21.4255 13.6233 21.168L21.6133 10.182C21.8669 9.83605 22.0025 9.41776 22.0001 8.98885C21.9978 8.55995 21.8576 8.14316 21.6003 7.8L18.6003 3.8C18.414 3.55161 18.1725 3.35 17.8948 3.21115C17.617 3.07229 17.3108 3 17.0003 3H7.00033C6.68925 3.00004 6.38247 3.07264 6.10437 3.21204C5.82626 3.35144 5.58451 3.55379 5.39833 3.803L2.40033 7.8C2.14289 8.14306 2.00256 8.55979 2.00003 8.98869C1.99751 9.41759 2.13294 9.83594 2.38633 10.182L10.3763 21.168C10.5616 21.4255 10.8054 21.6352 11.0877 21.7799C11.37 21.9245 11.6831 22 12.0003 22ZM2.00033 9H22.0003'
        stroke='#6B7280'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default DiamondIcon;
